function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgFacebook = function SvgFacebook(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 40 40"
  }, props), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 21972",
    transform: "translate(-781 -224)"
  }, /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 1821",
    cx: 20,
    cy: 20,
    r: 20,
    transform: "translate(781 224)",
    style: {
      fill: "#1977f3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 17769",
    d: "m4209.989 2795.972.886-5.782h-5.546v-3.752c0-1.581.773-3.125 3.259-3.125h2.523v-4.922a30.726 30.726 0 0 0-4.478-.391c-4.567 0-7.555 2.767-7.555 7.782v4.407H4194v5.782h5.079v13.976a20.106 20.106 0 0 0 3.125.242 20.405 20.405 0 0 0 3.125-.242v-13.976z",
    transform: "translate(-3401.203 -2546.189)",
    style: {
      fill: "#fff"
    }
  })));
};

export default SvgFacebook;